import React, { useState } from "react";
import Icon from "./icons/Icon";
import { formatPhone } from "../utils/mask-number";
import { countryOptions } from "../utils/country";
import WIIASCEND from "../assets/images/wii-blue.png";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzdN6kba7P8TT9xoYX1M8XM8lcFP2uRlHldDzfnxfmM6YpO-CNXcHmbkLDONcJVmQRk/exec";

const SCRIPT_URL_CONOSCO =
  "https://script.google.com/macros/s/AKfycbx1rS9-Nl3O1O60lC0mXUf5TRx-WYJXFkcoPJGjj0aJgTl5fOy53xlpGZsgpI6ogl3s4w/exec";

const OptionModal = ({ isOpen, closeModal }) => {
  if (!isOpen) return null;

  const [selectedOption, setSelectedOption] = useState(null);
  const [country, setCountry] = useState(countryOptions[0]);
  const [status, setStatus] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const allDigits = value.replace(/\D/g, "");
      const localDigits = allDigits.startsWith(country.ddi)
        ? allDigits.slice(country.ddi.length)
        : allDigits;
      const formattedLocal = formatPhone(localDigits, country.value);
      const newValue = `${country.ddi} ${formattedLocal}`;
      setForm((prev) => ({ ...prev, phone: newValue }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCountryChange = (e) => {
    const sel = countryOptions.find((c) => c.value === e.target.value);
    if (!sel) return;
    setCountry(sel);
    setForm((prev) => ({ ...prev, phone: "" }));
  };

  function handleOpenAccount(e) {
    e.preventDefault();
    setStatus("Enviando...");

    window.__onFormSubmit = (resp) => {
      const screenSize = window.innerWidth;
      if (resp.status === "success") {
        setStatus(
          "Enviado! Estaremos lhe redirecionando para o Internet Banking."
        );
        setForm({ name: "", email: "", phone: "", message: "" });
        if (screenSize < 640) {
          window.location.href = "https://banking.wiiascend.com/";
        } else {
          window.location.href =
            "https://banking.wiiascend.com/create-account-desck";
        }
      } else {
        setStatus("Erro: " + (resp.message || "desconhecido"));
      }
      document.getElementById("__jsonpForm").remove();
    };

    const params = new URLSearchParams({
      name: form.name,
      number: form.phone,
      description: "Fluxo criar conta",
      callback: "__onFormSubmit",
    }).toString();

    const script = document.createElement("script");
    script.src = `${SCRIPT_URL}?${params}`;
    script.id = "__jsonpForm";
    document.body.appendChild(script);
  }

  function handleWorkSubmit(e) {
    e.preventDefault();
    setStatus("Enviando...");

    window.__onFormSubmit = (resp) => {
      if (resp.status === "success") {
        setStatus("Enviado com sucesso!");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("Erro: " + (resp.message || "desconhecido"));
      }
      document.getElementById("__jsonpForm").remove();
    };

    const params = new URLSearchParams({
      name: form.name,
      email: form.email,
      description: form.message,
      number: form.phone,
      callback: "__onFormSubmit",
    }).toString();

    const script = document.createElement("script");
    script.src = `${SCRIPT_URL_CONOSCO}?${params}`;
    script.id = "__jsonpForm";
    document.body.appendChild(script);
  }

  function handleForeignerSubmit(e) {
    e.preventDefault();
    setStatus("Sending...");

    window.__onFormSubmit = (resp) => {
      if (resp.status === "success") {
        setStatus("Sent! The Onboarding will completed in 24 hours.");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("Error: " + (resp.message || "unknown"));
      }
      document.getElementById("__jsonpForm").remove();
    };

    const params = new URLSearchParams({
      name: form.name,
      email: form.email,
      description: form.message,
      number: form.phone,
      callback: "__onFormSubmit",
    }).toString();

    const script = document.createElement("script");
    script.src = `${SCRIPT_URL}?${params}`;
    script.id = "__jsonpForm";
    document.body.appendChild(script);
  }

  const options = [
    { id: 1, value: "open-account", label: "Quero abrir minha conta" },
    { id: 2, value: "contact", label: "Fale com um especialista" },
    { id: 3, value: "work", label: "Trabalhe conosco" },
    { id: 4, value: "foreigner", label: "I'm a foreigner (Sou estrangeiro)" },
  ];

  const isOpenAccount = selectedOption === "open-account";
  const isGetContact = selectedOption === "contact";
  const isWorkWith = selectedOption === "work";
  const isForeigner = selectedOption === "foreigner";

  const openModal = () => {
    isOpen(true);
  };

  const handleOptionChange = (optionValue) => {
    setSelectedOption(optionValue);
  };

  const handleSubmit = () => {
    if (!selectedOption) {
      alert("Por favor, selecione uma opção");
      return;
    }

    if (isGetContact) {
      window.open("https://wa.me/554891081427", "_blank");
    } else {
      alert("Por favor, selecione uma opção");
      return;
    }
    closeModal();
  };

  return (
    <div className="relative">
      {isOpen && (
        <div
          className="fixed inset-0 backdrop-blur-[3px]  z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-lg max-h-[800px] overflow-y-auto transition-all ease-in-out duration-300  border border-black shadow-xl w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <div className=" flex flex-col bg-white  px-6  pt-6 items-center justify-center">
              <div className=" flex flex-row bg-white h-auto w-full items-center justify-between">
                <img
                  src={WIIASCEND}
                  alt="WIIASCEND"
                  className="w-[200px] justify-start h-auto"
                />
                <button
                  onClick={closeModal}
                  className="justify-center items-center bg-transparent text-black"
                >
                  <Icon name="CloseX" className="w-full h-auto" />
                </button>
              </div>

              <div className=" flex flex-row  bg-white h-auto w-full items-center justify-start">
                <h2 className="text-xl font-bold text-black">
                  Selecione uma opção:
                </h2>
              </div>
            </div>

            <div className="p-6 space-y-6">
              <div className="space-y-2">
                {options.map((option) => (
                  <label
                    key={option.id}
                    className={`flex items-center space-x-4 p-2 hover:bg-gray-50 cursor-pointer transition-colors ${
                      selectedOption === option.value
                        ? "border-blue-500 bg-blue-50"
                        : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="modalOption"
                      value={option.value}
                      checked={selectedOption === option.value}
                      onChange={() => handleOptionChange(option.value)}
                      className={`h-5 w-5 accent-[#887443] bg-white-100`}
                    />
                    <span className="text-gray-800 font-sm">
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>

              <div className=" justify-start space-x-3">
                {isWorkWith && (
                  <>
                    <div className="space-y-4">
                      <form
                        onSubmit={handleWorkSubmit}
                        className="mt-4 space-y-4"
                      >
                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="name"
                              className="block text-black/80 font-sm"
                            >
                              Nome completo
                            </label>
                            <input
                              name="name"
                              value={form.name}
                              onChange={handleChange}
                              type="text"
                              id="name"
                              placeholder="Digite aqui"
                              required
                              className="w-full text-black mt-2 px-4 py-2 shadow-md rounded-xs"
                            />
                          </div>
                        </div>
                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="email"
                              className="block text-black/80 font-sm"
                            >
                              E-mail
                            </label>
                            <input
                              name="email"
                              value={form.email}
                              onChange={handleChange}
                              type="email"
                              id="email"
                              placeholder="email@exemplo.com"
                              required
                              className="w-full text-black font-sm mt-2 px-2 py-2 shadow-md rounded-xs"
                            />
                          </div>
                        </div>

                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="phone"
                              className="block text-black/80 font-sm"
                            >
                              Telefone para contato
                            </label>

                            <div className="mt-2 flex gap-2">
                              <select
                                id="country"
                                value={country.value}
                                onChange={handleCountryChange}
                                className="flex w-full px-3 py-2 shadow-md font-sm rounded-xs text-black/70"
                              >
                                {countryOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label} (+{opt.ddi})
                                  </option>
                                ))}
                              </select>

                              <input
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                type="tel"
                                id="phone"
                                placeholder={`(${country.ddi}) 00000-0000`}
                                className="flex w-full text-black px-4 py-2 shadow-md rounded-xs"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="message"
                            className="block text-black/80 font-sm"
                          >
                            LinkedIn
                          </label>
                          <input
                            name="message"
                            value={form.message}
                            onChange={handleChange}
                            id="message"
                            rows="1"
                            placeholder="Insira o url"
                            required
                            className="w-full mt-2  text-black px-4 py-2 shadow-md rounded-xs"
                          />
                        </div>
                        <script>
                          const phoneInputField =
                          document.querySelector("#phone"); const phoneInput =
                          window.intlTelInput(phoneInputField,{" "}
                          {
                            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
                          }
                          );
                        </script>

                        <button
                          type="submit"
                          className="px-4 py-2 bg-[#887443] rounded-xs text-white hover:bg-[#887443]/90 transition-colors disabled:opacity-50"
                        >
                          Enviar
                        </button>

                        {status && (
                          <p className="mt-2 text-center text-sm text-gray-700">
                            {status}
                          </p>
                        )}
                      </form>
                    </div>
                  </>
                )}
                {isForeigner && (
                  <>
                    <div className="space-y-4">
                      <form
                        onSubmit={handleForeignerSubmit}
                        className="mt-4 space-y-4"
                      >
                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="name"
                              className="block text-black/80 font-sm"
                            >
                              Full name
                            </label>
                            <input
                              name="name"
                              value={form.name}
                              onChange={handleChange}
                              type="text"
                              id="name"
                              placeholder="Type here"
                              required
                              className="w-full text-black mt-2 px-4 py-2 shadow-md rounded-xs"
                            />
                          </div>
                        </div>

                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="email"
                              className="block text-black/80 font-sm"
                            >
                              E-mail
                            </label>
                            <input
                              name="email"
                              value={form.email}
                              onChange={handleChange}
                              type="email"
                              id="email"
                              placeholder="email@exemple.com"
                              required
                              className="w-full text-black mt-2 px-4 py-2 shadow-md rounded-xs"
                            />
                          </div>
                        </div>

                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="phone"
                              className="block text-black/80 font-sm"
                            >
                              Phone number
                            </label>

                            <div className="mt-2 flex gap-2">
                              <select
                                id="country"
                                value={country.value}
                                onChange={handleCountryChange}
                                className="flex w-full px-3 py-2 font-sm shadow-md rounded-xs text-black/70"
                              >
                                {countryOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label} (+{opt.ddi})
                                  </option>
                                ))}
                              </select>

                              <input
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                type="tel"
                                id="phone"
                                placeholder={`(${country.ddi}) 00000-0000`}
                                className="flex w-full text-black px-4 py-2 shadow-md rounded-xs"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="mb-4">
                          <label
                            htmlFor="message"
                            className="block text-black/80 font-sm"
                          >
                            Passport or Driver's License
                          </label>
                          <input
                            name="message"
                            value={form.message}
                            onChange={handleChange}
                            id="message"
                            placeholder="Enter document number"
                            required
                            className="w-full mt-2 text-black px-4 py-2 shadow-md rounded-xs"
                          />
                        </div>
                        <script>
                          const phoneInputField =
                          document.querySelector("#phone"); const phoneInput =
                          window.intlTelInput(phoneInputField,{" "}
                          {
                            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
                          }
                          );
                        </script>
                        <button
                          type="submit"
                          className="px-4 py-2 bg-[#887443] text-white rounded-xs hover:bg-[#887443]/90 transition-colors disabled:opacity-50"
                        >
                          Send
                        </button>

                        {status && (
                          <p className="mt-2 text-center text-sm text-gray-700">
                            {status}
                          </p>
                        )}
                      </form>
                    </div>
                  </>
                )}

                {isOpenAccount && (
                  <>
                    <div className="space-y-4">
                      <form
                        onSubmit={handleOpenAccount}
                        className="mt-4 space-y-4"
                      >
                        <div className="mb-4 flex gap-4"></div>
                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="name"
                              className="block text-black/80 font-sm"
                            >
                              Nome completo
                            </label>
                            <input
                              name="name"
                              value={form.name}
                              onChange={handleChange}
                              type="text"
                              id="name"
                              placeholder="Digite aqui"
                              required
                              className="w-full text-black mt-2 px-4 py-2 shadow-md rounded-xs"
                            />
                          </div>
                        </div>

                        <div className="mb-4 flex gap-4">
                          <div className="w-full">
                            <label
                              htmlFor="phone"
                              className="block text-black/80 font-sm"
                            >
                              Telefone para contato
                            </label>

                            <div className="mt-2 flex gap-2">
                              <select
                                id="country"
                                value={country.value}
                                onChange={handleCountryChange}
                                className="flex w-full px-3 py-2 shadow-md font-sm rounded-xs text-black/70"
                              >
                                {countryOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label} (+{opt.ddi})
                                  </option>
                                ))}
                              </select>

                              <input
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                type="tel"
                                id="phone"
                                placeholder={`(${country.ddi}) 00000-0000`}
                                className="flex w-full text-black px-4 py-2 shadow-md rounded-xs"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <script>
                          const phoneInputField =
                          document.querySelector("#phone"); const phoneInput =
                          window.intlTelInput(phoneInputField,{" "}
                          {
                            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
                          }
                          );
                        </script>

                        <button
                          type="submit"
                          className="px-4 py-2 bg-[#887443] rounded-xs text-white hover:bg-[#887443]/90 transition-colors disabled:opacity-50"
                        >
                          Enviar
                        </button>

                        {status && (
                          <p className="mt-2 text-center text-sm text-gray-700">
                            {status}
                          </p>
                        )}
                      </form>
                    </div>
                  </>
                )}

                {isGetContact && (
                  <button
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-[#887443] text-white rounded-xs hover:bg-[#887443]/90 transition-colors disabled:opacity-50"
                  >
                    Abrir no WhatsApp
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptionModal;
